import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FBoxContainer } from '../../../../../../../components/base';
import { FORTA_BLUE } from '../../../../../../../utils/colors';
import CheckIconLabel from '../checkIconLabel/CheckIconLabel';
import { getEvidencedBasedInterventionsData } from '../../../../constants';

import type { IEvidenceBasedInterventionsUsed } from '../../../../../../../utils/types';

interface IInterventionsReadOnlProps {
  evidenceBasedInterventionsUsed?: IEvidenceBasedInterventionsUsed;
}

function InterventionsReadOnly({ evidenceBasedInterventionsUsed }: IInterventionsReadOnlProps) {
  const { t } = useTranslation('sessionNotes');
  return evidenceBasedInterventionsUsed ? (
    <FBoxContainer
      sx={{
        mt: 3,
        position: 'relative',
        borderRadius: '10px',
        boxShadow: 'none',
      }}
      contentStyle={{
        pt: 2.5,
      }}
    >
      <Typography fontSize={21} color={FORTA_BLUE.primary} textAlign="left">
        {t('evidenceBasedInterventionsUsed.title')}
      </Typography>
      <Grid container sx={{ flexFlow: 1, mt: 1 }}>
        <Grid
          item
          sx={{
            borderRight: `1px solid ${FORTA_BLUE.light2}`,
            borderRightWidth: { xs: 0, md: '1px' },
          }}
          pr={{
            md: 2,
            xs: 0,
          }}
          md={4}
          xs={12}
        >
          {getEvidencedBasedInterventionsData(t)
            .filter((item) => item.columnNumber === 1)
            .map((item) =>
              item.id === 'functional_behavior_assessment' &&
              evidenceBasedInterventionsUsed.functional_behavior_assessment === null ? null : (
                <CheckIconLabel
                  checked={Boolean(
                    evidenceBasedInterventionsUsed[item.id],
                  )}
                  label={item.label}
                  key={item.id}
                  tooltipContent={item.description}
                />
              ),
            )}
        </Grid>
        <Grid
          item
          sx={{
            borderRight: `1px solid ${FORTA_BLUE.light2}`,
            borderRightWidth: { xs: 0, md: '1px' },
          }}
          px={{
            md: 2,
            xs: 0,
          }}
          md={4}
          xs={12}
        >
          {getEvidencedBasedInterventionsData(t)
            .filter((item) => item.columnNumber === 2)
            .map((item) => (
              <CheckIconLabel
                checked={Boolean(
                  evidenceBasedInterventionsUsed[item.id],
                )}
                label={item.label}
                key={item.id}
                tooltipContent={item.description}
              />
            ))}
        </Grid>
        <Grid
          item
          md={4}
          xs={12}
          pl={{
            md: 2,
            xs: 0,
          }}
        >
          {getEvidencedBasedInterventionsData(t)
            .filter((item) => item.columnNumber === 3)
            .map((item) => (
              <CheckIconLabel
                checked={Boolean(
                  evidenceBasedInterventionsUsed[item.id],
                )}
                label={item.label}
                key={item.id}
                tooltipContent={item.description}
              />
            ))}
          <CheckIconLabel
            label={`${t('evidenceBasedInterventionsUsed.fields.other')}: ${
              evidenceBasedInterventionsUsed.other ? evidenceBasedInterventionsUsed.other : 'N/A'
            }`}
            key={'other'}
            checked={Boolean(evidenceBasedInterventionsUsed.other)}
          />
        </Grid>
      </Grid>
    </FBoxContainer>
  ) : null;
}

export default InterventionsReadOnly;
